export default __webpack_public_path__ + "images/02c7a43c8f5bcfdb3feefcbb5a053f22.png";